//ResourceTypes
export const TransactionActionTypes = {
  ASYNC_TRANSACTIONS_SUMMARY_ADMIN: '@schedule/ASYNC_TRANSACTIONS_SUMMARY_ADMIN',
  CHANGE_TRANSACTIONS_SUMMARY: '@schedule/CHANGE_TRANSACTIONS_SUMMARY',
  LOADING_TRANSACTIONS_SUMMARY: '@schedule/LOADING_TRANSACTIONS_SUMMARY',
  ASYNC_BALANCE_ADMIN: '@schedule/ASYNC_BALANCE_ADMIN',
  CHANGE_BALANCE_ADMIN: '@schedule/CHANGE_BALANCE_ADMIN',
  LOADING_BALANCE_ADMIN: '@schedule/LOADING_BALANCE_ADMIN',
};

const INITIAL_STATE = {
  transactionsSummary: [],
  loadingSummary: false,
  balanceAdmin: null,
  loadingBalanceAdmin: false,

}

const TransactionAdminReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case TransactionActionTypes.CHANGE_TRANSACTIONS_SUMMARY:
      return { ...state, transactionsSummary: payload}
    case TransactionActionTypes.LOADING_TRANSACTIONS_SUMMARY:
      return { ...state, loadingSummary: payload}
    case TransactionActionTypes.CHANGE_BALANCE_ADMIN:
     return { ...state, balanceAdmin: payload };
    case TransactionActionTypes.LOADING_BALANCE_ADMIN:
     return { ...state, loadingBalanceAdmin: payload };
    default:
      return state;
  }
}

//Actions
export const asyncTransactionsSummaryAdmin= (payload) => ({
  type: TransactionActionTypes.ASYNC_TRANSACTIONS_SUMMARY_ADMIN,
  payload,
});

export const changeTransactionsSummary = (payload) => ({
  type: TransactionActionTypes.CHANGE_TRANSACTIONS_SUMMARY,
  payload,
});

export const loadingTransactionsSummary = (payload) => ({
  type: TransactionActionTypes.LOADING_TRANSACTIONS_SUMMARY,
  payload,
});

//Actions (balance admin)
export const asyncBalanceAdmin = (payload) => ({
  type: TransactionActionTypes.ASYNC_BALANCE_ADMIN,
  payload,
});
export const changeBalanceAdmin = (payload) => ({
  type: TransactionActionTypes.CHANGE_BALANCE_ADMIN,
  payload,
});
export const loadingBalanceAdmin = (payload) => ({
  type: TransactionActionTypes.LOADING_BALANCE_ADMIN,
  payload,
});

export default TransactionAdminReducer;
